module.exports = __webpack_public_path__ + "static/img/new-product.9a3ad22.png";